import React, { useEffect } from 'react';
import '../../assets/css/views/login.css'

const generatePKCE = async () => {
	const array = new Uint8Array(32);
	window.crypto.getRandomValues(array);
	const codeVerifier = btoa(String.fromCharCode(...array))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=+$/, "");

	const encoder = new TextEncoder();
	const data = encoder.encode(codeVerifier);
	const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);

	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const base64 = btoa(String.fromCharCode(...hashArray))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=+$/, "");

	return { codeVerifier, codeChallenge: base64 };
};

export const Login = () => {
  // Solicitar permiso de notificación push cuando el componente se monte
	useEffect(() => {
		const requestNotificationPermission = async () => {
			if ('Notification' in window && navigator.serviceWorker) {
        try {
          const permission = await Notification.requestPermission();
          if (permission === 'granted') {
          // Aquí podrías agregar la lógica para registrar un service worker y suscribirte a las notificaciones push
          } else {
          }
        } catch (error) {
          console.error('Error al solicitar permisos de notificación:', error);
        }
			}
		};

		// Llamar la función para solicitar permiso
		requestNotificationPermission();
	}, []);

    const rolesScopes = [
        {nombre: "Administrador", descripcion: "Acceso Total", scopes: "teguio-web-administrador.read teguio-web-administrador.write openid profile "},
        {nombre: "Manager (Chat)", descripcion: "Validar recargas ",scopes:"teguio-web-manager.read teguio-web-manager.write openid profile"},
    ]

    const iniciarSesionConAbexa = async (scopes) => {
      const result = await generatePKCE();
      localStorage.setItem("pkce", JSON.stringify(result))

      const searchParameters = new URLSearchParams({
        response_type: 'code',
        client_id: process.env.REACT_APP_WSO2IS_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
        scope: scopes + ' ' + process.env.REACT_APP_SCOPES_TOKEN,
        state: 'ThisIsMyStateValue',
        code_challenge: result.codeChallenge,
        code_challenge_method: 'S256',
        id_carga: Date.now()
      })
      const urlEnvio = `${process.env.REACT_APP_WSO2IS_AUTHORIZATION}/authorize?` + searchParameters
      try {
        localStorage.setItem("scopes",`"${scopes}"`)
        window.location.href = urlEnvio;
      } catch (error) {
        console.error('Error en la solicitud:', error);
      }
    }


    return (
        <>  
          <div className="flex h-screen lg:flex-col overflow-y-hidden">
          <div className='flex flex-col items-end lg:items-center lg:pt-5 justify-center lg:w-full w-[50%] bg-slate-900'>
            <div className='flex flex-col items-center px-5 mb-10 relative'>
              {/* <div className='flex items-center  '>
                <img className='w-[150px] mb-5 container' src={'https://cdn-icons-png.flaticon.com/512/6995/6995660.png'} alt=''/>
              </div> */}
              <div className='relative '>
                <img 
                  className='container w-[400px] lg:w-[200px]'
                  src={'https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=teguio&NombreImagen=fotos-comunidad%2FlogoComuniChat'}
                  alt=''
                />
                {/* <img className='container w-auto absolute top-[-45px] left-1/2 transform -translate-x-1/2' src={logoAbeja} alt=''/> */}
              </div>
            </div>
          </div>

            <div className="flex flex-col items-start lg:items-center lg:justify-start lg:pt-5 justify-center lg:w-full lg:h-full text-2xl text-white w-[50%] bg-gray-800 ">
              <div className=' flex flex-col  max-h-[70%] containerScroll overflow-y-auto'>
                <div className='flex mx-10'>Iniciar Sesión</div>
                {
                  rolesScopes?.map((rs, i)=>( 
                    <div key={i+1} className={`
                        flex flex-col m-1
                        `}
                    >
                    <button 
                        onClick={()=>iniciarSesionConAbexa(rs.scopes)}
                        key={i}
                        className={`
                        bg-blue-800 hover:bg-blue-700
                        text-xl 
                        py-2 px-10 rounded
                        `}
                    >
                        {rs.nombre}
                    </button>
                        {/* <span className='mb-1 text-gray-200 text-center text-xs'>{rs.descripcion}</span> */}
                    </div>
                  ))
                }
              </div>
            </div>
      
          </div>
        </>
      );
      
}

